"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_color_1 = require("react-color");
const ColorPicker = (props) => {
    var _a, _b;
    const selectColor = () => {
        props.closeColorModal();
    };
    let buttonStyle = {
        border: "1px solid #dcdcdc", backgroundColor: "#fafafa", borderRadius: '4px', fontSize: '14px', padding: "0px 13px", lineHeight: '28px'
    };
    if (props.settings && props.settings.buttonStyle) {
        buttonStyle = props.settings.buttonStyle;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { maxWidth: 380, margin: "0px auto" } }, { children: [(0, jsx_runtime_1.jsx)("div", { style: {
                            backgroundColor: props.settings.value,
                            height: 100,
                            marginBottom: 20,
                        } }), (0, jsx_runtime_1.jsx)(react_color_1.SliderPicker, { color: (_a = props.settings) === null || _a === void 0 ? void 0 : _a.value, onChangeComplete: (color) => {
                            props.onChangeEvent(color.hex);
                        } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { marginTop: 20, textAlign: "center" } }, { children: (0, jsx_runtime_1.jsx)(react_color_1.CompactPicker, { colors: props.moreColors, className: "custom-color-picker", color: (_b = props.settings) === null || _b === void 0 ? void 0 : _b.value, onChangeComplete: (color) => {
                                props.onChangeEvent(color.hex);
                            } }) }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { textAlign: 'center', marginTop: '15px' } }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ style: buttonStyle, className: "btn-theme-default", onClick: selectColor }, { children: "Select" })) }))] }));
};
exports.default = ColorPicker;
